module.exports = __webpack_public_path__ + "media/img/illustrations/proposals-45b6fda5db58d6a6150e293e5abd9846.svg";